import React from 'react';
import BSForm from 'react-bootstrap/Form';
import styled from 'styled-components';

const RemainingText = styled.div`
    position: absolute;
    right: 30px;
    bottom: 30px;
    color: #BDBDBD;
    font-size: 14px;
`

interface TextAreaFieldProps {
    name: string
    label: string
    placeholder?: string
    value?: string
    required?: boolean
    readonly?: boolean
    rows?: number
    limit?: number
    style?: React.CSSProperties
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({ name, label, placeholder, value, required, readonly, rows, limit, style, onChange }) => {
    return (
        <BSForm.Group>
            <BSForm.Label>{label}{required ? '*' : ""}</BSForm.Label>
            <BSForm.Control
                id={name}
                name={name}
                as="textarea"
                placeholder={placeholder}
                value={value}
                readOnly={readonly}
                maxLength={limit}
                rows={rows}
                style={style}
                onChange={onChange} />
            <RemainingText>{`(${(value || '').length}/${limit})`}</RemainingText>
        </BSForm.Group>
    )
}

export default TextAreaField
